import Client from '../client';

export function getFeaturedSchools() {
  return Client.get('/featured_schools/');
}

export function getSchools() {
  return Client.get('/schools/');
}
